import { useRetrieveListByGet } from 'src/compass/shared/hooks/reactQuery/useRetrieveListByGet';

export default function useSiteProperties() {
  const query = useRetrieveListByGet({
    url: 'Public/Properties/Site',
    staleTime: Infinity,
  });

  const isProductionDatabase = query.data?.databaseName?.toLowerCase() === 'production';

  return { ...query, isProductionDatabase };
}
